export const STEPS = ['core', 'support', 'styling', 'accessories', 'review'];

export const CERTAIN_STEPS = [
  'styling',
  'core',
  'support',
  'accessories',
  'review',
];
export const BOLT_STEPS = [
  'core',
  'support',
  'styling',
  'panel_print',
  'accessories',
  'review',
];

export const SERVER_STEPS = ['core', 'support', 'review'];

export const STEPS_TITLE = {
  core: 'CORE',
  support: 'Support',
  styling: 'STYLING',
  accessories: 'Accessories',
  review: 'Review',
};

export const BOLT_STEPS_TITLE = {
  core: 'CORE',
  support: 'Support',
  styling: 'STYLING',
  panel_print: 'Panel Prints',
  accessories: 'Accessories',
  review: 'Review',
};

export const STEPS_PAGE_TITLES = {
  core: 'CREATE YOUR DREAM RIG',
  support: 'STRENGTHEN YOUR DREAM RIG',
  styling: 'PERSONALISE YOUR DREAM RIG',
  accessories: 'ACCESSORISE YOUR DREAM RIG',
  review: 'CONFIRM YOUR DREAM RIG',
  build: 'CREATE YOUR DREAM RIG',
  chassis: 'CREATE YOUR DREAM RIG',
  panel_print: 'DESIGN YOUR CHASSIS',
};
